import styled, { css } from "styled-components";

import { IllustrationContainerContainer } from "shared/components/organisms/AppNotification/components/atoms/IllustrationContainer/styles";
import { NotificationContainerWrapper } from "shared/components/organisms/AppNotification/components/atoms/NotificationContainer/styles";

interface IActivitieDataEndingNotificationContainerProps {
  shouldChangeBackground: boolean;
}

export const ActivitieDataEndingNotificationContainer = styled.div<IActivitieDataEndingNotificationContainerProps>`
  ${({ shouldChangeBackground }) =>
    shouldChangeBackground
      ? css`
          ${NotificationContainerWrapper} {
            background: linear-gradient(
              90deg,
              rgba(66, 142, 255, 0.12) 0%,
              rgba(28, 59, 105, 0.12) 100%
            );

            border-left: 2px solid #428eff;
          }
        `
      : css`
          button {
            background-color: white;
            color: #1d1c1f;
          }
        `}

  .content-image {
    padding: 8px;

    border-radius: 4px;

    margin-top: 1rem;

    border: 1px solid ${({ theme }) => theme.notification.contentBorderColor};

    display: flex;
    align-items: center;
    gap: 10px;

    img {
      border-radius: 3px;
    }

    span {
      font: 500 0.8125rem/1.3125rem "Inter";

      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }

  button {
    margin: 1rem 0;
  }

  ${IllustrationContainerContainer} {
    svg {
      color: ${({ theme }) => theme.notification.highlightText};
    }
  }
`;
